import angular from 'angular';
import {
  loaderService,
  orgDataService,
  authorizationService,
  userService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon
} from 'app/components/global';
import controller from './release-note.controller';
import directive from './release-note.directive';


const releaseNoteModule = angular.module('app.components.support.releaseNote', [
  alerts,
  authorizationService,
  actionIcon,
  confirmDialog,
  loaderService,
  orgDataService,
  userService,
])
  .directive('releaseNote', directive)
  .controller('ReleaseNoteController', controller);

export default releaseNoteModule.name;

console.log('app.components.support.releaseNote created');
